import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { merge } from 'lodash-es';
import { FUSE_APP_CONFIG } from '@fuse/services/config/config.constants';

@Injectable({
    providedIn: 'root'
})
export class FuseConfigService
{
    private _config: BehaviorSubject<any>;

    /**
     * Constructor
     */
    constructor(@Inject(FUSE_APP_CONFIG) config: any)
    {
        // Restore persisted user preferences (scheme & theme) from localStorage
        const saved = localStorage.getItem('fuseConfig');
        const persisted = saved ? JSON.parse(saved) : {};

        // Validate that the saved theme exists in the current config
        if (persisted.theme && config.themes) {
            const themeExists = config.themes.some((theme: any) => theme.id === persisted.theme);
            if (!themeExists) {
                // If theme doesn't exist, remove it to use default
                delete persisted.theme;
            }
        }

        const initialConfig = merge({}, config, persisted);

        // Private
        this._config = new BehaviorSubject(initialConfig);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    set config(value: any)
    {
        // Merge the new config over to the current config
        const config = merge({}, this._config.getValue(), value);

        // Persist user preferences (scheme & theme) to localStorage
        const toSave: any = {};
        if (config.scheme !== undefined) { toSave.scheme = config.scheme; }
        if (config.theme  !== undefined) { toSave.theme  = config.theme;  }
        localStorage.setItem('fuseConfig', JSON.stringify(toSave));

        // Execute the observable
        this._config.next(config);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get config$(): Observable<any>
    {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void
    {
        // Set the config
        this._config.next(this.config);
    }
}
